"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const ess_api_1 = require("../ess-api");
/**
 * fixme: add document
 */
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    return [
        {
            datakey: 'syncTime',
            name: intl.formatMessage({
                id: 'ESS_COMPONENTS_COLUMN_SYNC_TIME',
                defaultMessage: 'Čas synchronizace',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.DateTimeCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'type',
            name: intl.formatMessage({
                id: 'ESS_COMPONENTS_COLUMN_TYPE',
                defaultMessage: 'Typ',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(ess_api_1.useComponentTypes),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(ess_api_1.useComponentTypes),
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=components-columns.js.map